import React from 'react';
import PropTypes from 'prop-types';

export const RadioButton = ({
    id,
    value,
    checked,
    children,
    handleOnChange,
    radioButtonClassName,
    labelClassName
}) => (
    <div className={`form-check pt-1 ${radioButtonClassName}`} key={value}>
        <input
            type="radio"
            name={id}
            id={`${id}-${value}`}
            className="form-check-input"
            value={value}
            checked={value === checked}
            onChange={e => {
                handleOnChange(e.target.value, e);
            }}
        />
        <label
            className={`form-check-label ml-1 ${labelClassName}`}
            htmlFor={`${id}-${value}`}>
            {children}
        </label>
    </div>
);

RadioButton.propTypes = {
    value: PropTypes.string,
    checked: PropTypes.string,
    children: PropTypes.node,
    handleOnChange: PropTypes.func,
    id: PropTypes.string.isRequired,
    radioButtonClassName: PropTypes.string
};

RadioButton.defaultProps = {
    radioButtonClassName: '',
    labelClassName: ''
};
